<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.service_request_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #000">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Service Main Data ==== -->
      <form>
        <div class="row">
          <h6 class="col-12 mb-3">{{ $t("PLACEHOLDERS.providerInfo") }}</h6>

          <!-- Start:: Provider Name Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
            disabled
          />
          <!-- End:: Provider Name Input -->

          <!-- Start:: Provider Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.office_type')"
            v-model.trim="data.provider_type"
            disabled
          />
          <!-- End:: Provider Type Input -->

          <!-- Start:: Provider Phone Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.provider_phone"
            disabled
          />
          <!-- End:: Provider Phone Input -->

          <h6 class="col-12 mb-3 mt-4">{{ $t("PLACEHOLDERS.serviceInfo") }}</h6>

          <!-- Start:: Service Name Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_name_ar')"
            v-model.trim="data.service_name_ar"
            disabled
          />
          <!-- End:: Service Name Arabic Input -->

          <!-- Start:: Service Name English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_name_en')"
            v-model.trim="data.service_name_en"
            disabled
          />
          <!-- End:: Service Name English Input -->

          <!-- Start:: Price Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.suggested_price')"
            v-model.trim="data.price_display"
            disabled
          />
          <!-- End:: Price Input -->

          <!-- Start:: Status Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model.trim="data.status_display"
            disabled
          />
          <!-- End:: Status Input -->

          <!-- Start:: Creation Date Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Creation Date Input -->
        </div>
      </form>
      <!-- ==== End:: Service Main Data ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowServiceManagement",
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        provider_name: null,
        provider_type: null,
        provider_phone: null,
        service_name_ar: null,
        service_name_en: null,
        price_display: null,
        status_display: null,
        status: null,
        created_at: null,
        rejection_reason: null,
      },
      // End:: Data

      // Start:: Dialogs
      dialogReject: false,
      rejectionReason: "",
      rejectionErrors: {},
      // End:: Dialogs
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getItemData() {
      this.isWaitingRequest = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `additional-services/${this.$route.params.id}`,
        });

        const serviceData = res.data.data.AdditionalService;

        this.data = {
          provider_name: serviceData.provider?.name || null,
          provider_type: serviceData.provider?.exhibitor_type_trans || null,
          provider_phone: serviceData.provider?.mobile || null,
          service_name_ar: serviceData.name_ar || serviceData.name || null,
          service_name_en: serviceData.name_en || null,
          price_display:
            serviceData.price + " " + (serviceData.currency || "SAR"),
          status_display:
            serviceData.status_trans || this.getStatusText(serviceData.status),
          status: serviceData.status,
          created_at: serviceData.created_at || null,
          rejection_reason: serviceData.rejection_reason || null,
        };

        this.isWaitingRequest = false;
      } catch (error) {
        this.isWaitingRequest = false;
        console.log(error.response.data.message);
        this.$router.push({ path: "/servicesmanagement/all" });
      }
    },

    // Start:: Status Methods
    getStatusColor(status) {
      switch (status) {
        case "pending_review":
          return "orange";
        case "accepted":
          return "green";
        case "rejected":
          return "red";
        default:
          return "grey";
      }
    },

    getStatusText(status) {
      switch (status) {
        case "pending_review":
          return this.$t("PLACEHOLDERS.pending");
        case "accepted":
          return this.$t("PLACEHOLDERS.accepted");
        case "rejected":
          return this.$t("PLACEHOLDERS.rejected");
        default:
          return this.$t("PLACEHOLDERS.unknown");
      }
    },

    // Start:: CRUD Methods
    editItem() {
      this.$router.push({
        path: `/servicesmanagement/edit/${this.$route.params.id}`,
      });
    },

    async approveItem() {
      this.isWaitingRequest = true;
      try {
        await this.$axios({
          method: "POST",
          url: `additional-services/${this.$route.params.id}/change-status`,
          data: {
            status: "accepted",
          },
        });
        this.getItemData();
        this.$message.success(this.$t("MESSAGES.approvedSuccessfully"));
        this.isWaitingRequest = false;
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    selectRejectItem() {
      this.dialogReject = true;
      this.rejectionReason = "";
      this.rejectionErrors = {};
    },

    async confirmRejectItem() {
      this.rejectionErrors = {};
      if (!this.rejectionReason || !this.rejectionReason.trim()) {
        this.rejectionErrors.reason = [
          this.$t("MESSAGES.rejection_reason_required"),
        ];
        return;
      }

      this.isWaitingRequest = true;
      try {
        await this.$axios({
          method: "POST",
          url: `additional-services/${this.$route.params.id}/change-status`,
          data: {
            status: "rejected",
            rejection_reason: this.rejectionReason,
          },
        });
        this.dialogReject = false;
        this.getItemData();
        this.$message.success(this.$t("MESSAGES.rejectedSuccessfully"));
        this.isWaitingRequest = false;
      } catch (error) {
        this.dialogReject = false;
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    this.getItemData();
  },
};
</script>

<style scoped>
.single_step_form_content_wrapper {
  padding: 20px;
}

.actions_wrapper {
  margin-top: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.btn_approve {
  background-color: #28a745 !important;
  color: white !important;
}

.btn_reject {
  background-color: #dc3545 !important;
  color: white !important;
}

.btn_edit {
  background-color: #007bff !important;
  color: white !important;
}

.form_title_wrapper {
  margin-bottom: 20px;
}

.form_title_wrapper h4 {
  color: #333;
  font-weight: 600;
}
</style>
